import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-username",
  "use": "icon-username-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-username\"><path d=\"M491.52 901.12H61.44c0-253.44 286.72-307.2 286.72-307.2l81.92 204.8 40.96-20.48v-61.44h-20.48v-40.96h20.48v-20.48h40.96v20.48h20.48v40.96h-20.48v61.44l40.96 20.48 81.92-204.8s286.72 53.76 286.72 307.2H491.52z m0-286.72c-61.44 0-184.32-119.1936-184.32-266.24a85.79072 85.79072 0 0 1 2.048-18.432c0.69632-6.90176-3.01056-97.77152-2.048-104.448 17.05984-108.3392 84.45952-127.97952 162.11968-141.45536C476.59008 82.57536 504.48384 61.44 512 61.44s-5.5296 21.13536 1.76128 22.40512C591.0528 97.25952 658.45248 117.6576 675.84 225.28c1.16736 7.20896-0.75776 94.96576 0 102.4a109.42464 109.42464 0 0 1 0 20.48c0 147.0464-121.26208 266.24-184.32 266.24z\" p-id=\"6083\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/username.svg
// module id = QS/K
// module chunks = 12